function noOp() {
}
export {
  noOp
};
//# sourceMappingURL=noOp.js.map
